var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthService } from '@/app/@core/services/auth/auth.service';
import { OnInit } from '@angular/core';
import { UserMeService } from '@app/@core/services/user-me/user-me.service';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../../@core/utils';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(userMeService, sidebarService, menuService, layoutService, translate, authService) {
        this.userMeService = userMeService;
        this.sidebarService = sidebarService;
        this.menuService = menuService;
        this.layoutService = layoutService;
        this.translate = translate;
        this.authService = authService;
        this.position = 'normal';
        this.branches = [];
        this.companyOption = null;
        this.currentBranch = {
            id: -1,
        };
        this.isLoading = false;
        var cachedId = this.authService.getBranchId();
        if (cachedId === '') {
            this.currentBranch.id = -1;
        }
        else {
            this.currentBranch.id = Number.parseInt(cachedId);
        }
    }
    HeaderComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, e_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.isLoading = true;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 4, , 5]);
                        _c = (_b = (_a = this.branches).push).apply;
                        _d = [_a];
                        return [4 /*yield*/, this.userMeService.getBranches()];
                    case 2:
                        _c.apply(_b, _d.concat([_f.sent()]));
                        _e = this;
                        return [4 /*yield*/, this.userMeService.getUserInfo(true)];
                    case 3:
                        _e.userResponse = _f.sent();
                        this.company = this.userResponse.company;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _f.sent();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 5:
                        if (this.isAdmin()) {
                            this.companyOption = { id: -1, name: this.company.name };
                        }
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype.isAdmin = function () {
        return this.authService.isAdmin();
    };
    HeaderComponent.prototype.onBranchChange = function (e) {
        if (e === -1) {
            this.authService.setBranchId('');
        }
        else {
            this.authService.setBranchId(this.currentBranch.id.toString());
        }
        window.location.reload();
    };
    HeaderComponent.prototype.toggleSidebar = function () {
        this.sidebarService.toggle(true, 'menu-sidebar');
        this.layoutService.changeLayoutSize();
        return false;
    };
    HeaderComponent.prototype.goToHome = function () {
        this.menuService.navigateHome();
    };
    return HeaderComponent;
}());
export { HeaderComponent };
